import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import servicesData from "../../data/servicesData";

// react-slick only reacts to breakpoint *changes*, not the width at first
// load, so a phone would start with the desktop layout. Derive it ourselves.
const getSlidesToShow = () => {
  const w = window.innerWidth;
  if (w <= 600) return 1;
  if (w <= 900) return 2;
  if (w <= 1200) return 3;
  return 4;
};

const RitualEssentials = () => {
  const [slidesToShow, setSlidesToShow] = useState(getSlidesToShow);

  useEffect(() => {
    const onResize = () => setSlidesToShow(getSlidesToShow());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const isMobile = slidesToShow === 1;

  const settings = {
    dots: isMobile,
    arrows: !isMobile,
    infinite: true,
    speed: 700,
    slidesToShow,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    pauseOnHover: true,
    swipeToSlide: true,
  };

  return (
    <section className="ritual-section">
      <div className="ritual-container">
        {/* HEADING */}
        <div className="ritual-heading">
          <span>Service Offered</span>

          <h2>Professional Astrology Consultation</h2>
          <div className="about-heading-line">
            <img
              src="https://res.cloudinary.com/dbb2hkjri/image/upload/v1786441287/1684481897-flower-divider-horizontal-orange_f2omyx.svg"
              alt="Heading decoration"
            />
          </div>
          <p>
            Get personalized guidance from experienced Vedic Astrologers,
            Numerologists and Vastu Experts for every important decision in
            life.
          </p>
        </div>

        {/* SLIDER */}
        <div className="ritual-slider-wrapper">
          <Slider {...settings}>
            {servicesData.map((item) => (
              <div className="ritual-slide" key={item.id}>
                <div className="ritual-card">
                  {/* IMAGE */}
                  <div className="ritual-image">
                    <img src={item.image} alt={item.title} />

                    <div className="ritual-image-overlay"></div>
                  </div>

                  {/* CONTENT */}
                  <div className="ritual-card-content">
                    <h3>{item.title}</h3>

                    <p>{item.shortDescription}</p>

                    <div className="ritual-price">{item.price}</div>

                    <Link to="/consultation" className="ritual-book-btn">
                      Book Consultation
                    </Link>
                  </div>

                  {/* DECORATION */}
                  <span className="ritual-corner">✦</span>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default RitualEssentials;
